<template
    ><v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{
                $route.params.companyId === "new" ? "Add new" : activeCompany.name | t
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <general-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <integration-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <contact-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <ui-configurations-view-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import GeneralInfoEditTab from "./tabs/general-info-edit-tab";
import IntegrationInfoEditTab from "./tabs/integration-info-edit-tab";
import Store from "../../store";
import ContactInfoEditTab from "./tabs/contact-info-edit-tab";
import UiConfigurationsViewTab from "@/views/company/tabs/ui-configurations-view-tab.vue";

export default {
    name: "company-view",
    components: {UiConfigurationsViewTab, ContactInfoEditTab, IntegrationInfoEditTab, GeneralInfoEditTab },
    data() {
        return {
            tab: 0,
            tabs: ["General info", "Integration info", "Contact info", "UI configuration"]
        };
    },
    computed: {
        ...mapState([
            "activeCompany",
            "loadingCompanyData",
            "activeCompanyBanks",
            "activeCompanyOrigins",
            "activeCompanyAllowedIbans"
        ])
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.companyId === "new") {
            Store.commit("addNewCompany");
        } else {
            Store.dispatch("getCompanyData", this.$route.params.companyId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        closeDrawer() {
            this.$router.push({ name: "companies-list" });
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (document.activeElement.tagName !== "INPUT" && document.activeElement.tagName !== "TEXTAREA") {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        },
        async submitEdit() {
            if (this.activeCompany) {
                const response = await Store.dispatch("submitCompanyUpdate", {
                    company: this.activeCompany,
                    banks: this.activeCompanyBanks,
                    origins: this.activeCompanyOrigins ? this.activeCompanyOrigins : [],
                    allowed_ibans: this.activeCompanyAllowedIbans
                });
                if (response.status === 1) {
                    await this.$router.push({
                        name: "company-view",
                        params: { companyId: response.id, tab: this.tabs[this.tab] }
                    });
                    await Store.dispatch("getCompanies");
                    await Store.commit("setRequestSuccess", true);
                } else {
                    await Store.commit("setRequestError", true);
                    await Store.commit("setErrorMessage", "Failed");
                }
            } else {
                await Store.commit("setRequestError", true);
                await Store.commit("setErrorMessage", "Failed");
            }
        }
    }
};
</script>

<style scoped></style>
